import React from 'react';
import {Button, Image} from 'antd-mobile';
import {toPriceStr} from '@components/utils';
import {CurrentUserRankType} from '@/common-pages/leaderboard/types';
import {motion} from 'motion/react';
import {useShare} from '@/common-pages/hooks/share.hooks';

interface CurrentUserRankProps {
  currentUser: CurrentUserRankType;
}

const CurrentUserRank: React.FC<CurrentUserRankProps> = ({currentUser}) => {
  const {doShare} = useShare(true);
  return (
    <motion.div
      initial={{y: 100, opacity: 0}}
      animate={{y: 0, opacity: 1}}
      transition={{duration: 0.3, delay: 0.2}}>
      <div className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-4 z-50">
        <div className="h-[4.25rem] flex items-center w-full justify-between rounded bg-gradient-to-r gap-1.5">
          <div className="text-[#553A00] text-xs font-bold">
            {currentUser.rank || '--'}
          </div>
          <Image
            src={currentUser.avatar}
            className="rounded-full size-11"></Image>
          <div>
            <div className="font-medium text-gray-800 text-xs h-5 flex items-end">
              {currentUser.username}
            </div>
            <div className="mt-0.5 text-sm">
              Point:{' '}
              <span className="text-c2 font-semibold">
                {toPriceStr(currentUser.point, {
                  showCurrency: false,
                  suffixUnit: 'K',
                  overPrice: 10000,
                })}
              </span>
            </div>
          </div>
          <div className="text-center text-sm">
            <div className="text-gray-600 h-5 flex items-end">Bonus</div>
            <div className="text-c2 font-semibold mt-0.5">
              {toPriceStr(currentUser.bonus, {
                showCurrency: true,
                overPrice: 10000,
                suffixUnit: 'K',
              })}
            </div>
          </div>
          <Button
            onClick={() => {
              doShare();
            }}
            className="rounded-full overflow-hidden bg-gradient-to-t from-[#8700DA] to-[#7000FF] flex items-center justify-center text-white text-sm font-bold h-10 px-5">
            Invite
          </Button>
        </div>
      </div>
    </motion.div>
  );
};

export default CurrentUserRank;
